import { AddressType, ContactRoleType, LocationType } from "src/app/_common/_enum/module.enum";

export class RenewalA {
    selectedStep: string;
    renewalData: any = new RenewalForm();
}

export class RenewalForm{
    accountNumber: number = 0;

    company = {
        existingName: "",
        requestedName: "",
        reason: "",
        other: ""
    };
    isNewAddressRequested: boolean = false;
    addresses = {
        existing: [
            new BusinessAddress(),
            new MailingAddress(),
            new BillingAddress()
        ],
        requested: [
            new BusinessAddress(),
            new MailingAddress(),
            new BillingAddress()
        ]
    };
    
    isNewContactRequested: boolean = false;
    contacts = {
        existing: [
            new AuditContact(),
            new BillingContact()
        ],
        requested: [
            new AuditContact(),
            new BillingContact()
        ]
    }
    renewingPolicies = [];
    exposures = {
        newExposures: null, //Boolean
        newExposuresDetails : "",
        exposureChanged: null, //Boolean
        exposureChangedDetails: "",
        diceExposures: {
            estimatedAnnualGPC: "",
            expiringYearGPC: "",
            mediaType: [],
        },
        auExposures: {
            notApplicable: false,
            numberOfEmployees: null,
            numberOfEmployeesNotApplicable: false,
            numberOfPartners: null,
            numberOfPartnersNotApplicable: false,
            estimatedCostOfHire: null,
            estimatedCostOfHireNotApplicable: false,
        },
        umExposuresAccepted: null, //Boolean
        isThirdPartyIncluded: null //Boolean
    }

    quoteNeedByDate: string = "";
    attachments = [];
}

export class RenewingPolicies {
   
}

export class LocationObject{
    addressType : string = "";
    careof: string = "";
    label: string = "";
    addressLine1: string = "";
    addressLine2: string = "";
    city: string = "";
    state: string = "";
    zip: string = "";
    country: string = "";
    county: string = "";
    verified: string = "";
}
export class BusinessAddress extends LocationObject{
    addressType: string = AddressType.Business;
    label = LocationType.PRIMARY;
}
export class MailingAddress extends LocationObject{
    addressType : string = AddressType.Mailing;
    label = LocationType.MAILING_ADDRESS;
}
export class BillingAddress extends LocationObject{
    addressType : string = AddressType.Billing;
    label = LocationType.BILLING_ADDRESS;
}

export class BindForm {
    renewalNumber: any;
    billingType: string = '';
    paymentPlan: string = '';
    renewingPolicies: any = [];
    comment: string = '';
    attachments:any = [];
    acknowledge: any = {
        terms: false,
        payPremium: false
    };
}

export class PolicyCoverages {
    policyNumber: string = '';
    quoteDocument = null;
    renewOption: string = '';
    doNotRenewReason: string = '';
    remarks: string = '';
    isSubjectivities: boolean = false;
    coverages: any  = [];
}

export class AdditionalChangesCoverage {
    name: string = 'Additional Coverage';
    lobName: string = null;
    options: any = [
        {
            keyValueID: 'AdditionalChanges',
            fullText: 'Additional Changes',
            shortText: 'Additional Changes',
            description: 'Specify if any additional changes are needed to the above selected quote.',
            value: null,
            additionalInfo: null,
            isRequired: false
        }
    ];
}

export class TRIACoverage {
    name: string = 'Tria Coverage';
    lobName: string = null;
    options: any  = [
        {
            keyValueID: 'TriaCoverage',
            fullText: 'TRIA Coverage',
            shortText: 'TRIA Coverage',
            description: 'This is optional coverage. If accepting, you are accepting as quoted or the coverage will be added and reflected in the premium due. If declining, the coverage will not be included when bound.',
            value: null,
            additionalInfo: null,
            isRequired: false
        },
        {
            keyValueID: 'DeclinedAction',
            fullText: 'Please select one of the following:',
            shortText: 'Declined Action',
            description: '',
            value: null,
            additionalInfo: null,
            isRequired: false
        },
        {
            keyValueID: 'WaiverAction',
            fullText: 'Please upload a TRIA Waiver.',
            shortText: 'Waiver Action',
            description: '',
            value: null,
            additionalInfo: null,
            isRequired: false
        }
    ];
}

export class CyberCoverage {
    name: string = 'Cyber Coverage';
    lobName: string = null;
    options: any  = [
        {
            keyValueID: 'CyberCoverage',
            fullText: 'Cyber Suite Coverage',
            shortText: 'Cyber Suite Coverage',
            description: 'This is optional coverage. If accepting, you are accepting as quoted or the coverage will be added and reflected in the premium due. If declining, the coverage will not be included when bound.',
            value: null,
            additionalInfo: null,
            isRequired: false
        }
    ];
}

export class AutoCoverage {
    name: string = 'Auto Coverage';
    lobName: string = null;
    options: any  = [
        {
            keyValueID: 'NonOwnedAutoCoverage',
            fullText: 'Non-Owned and Hired Auto Liability Coverage',
            shortText: 'Non-Owned and Hired Auto Liability Coverage',
            value: null,
            description: 'This is optional coverage. If accepting, you are accepting as quoted or the coverage will be added and reflected in the premium due. If declining, the coverage will not be included when bound.',
            additionalInfo: null,
            isRequired: false
        },
        {
            keyValueID: 'NoofEmps',
            fullText: 'Number of Employees',
            shortText: 'Number of Employees',
            value: null,
            description: null,
            additionalInfo: null,
            isRequired: false
        },
        {
            keyValueID: 'NoofPartners',
            fullText: 'Number of Partners',
            shortText: 'Number of Partners',
            value: null,
            description: null,
            additionalInfo: null
        },
        {
            keyValueID: 'COH',
            fullText: 'Estimated Cost of Hire',
            shortText: 'Estimated Cost of Hire',
            value: null,
            description: null,
            additionalInfo: null,
            isRequired: false
        }
    ];
}

export class WCCoverage {
    name: string = 'Workers Compensation';
    lobName: string = null;
    options: any  = [
        {
            keyValueID: 'IncludedExcludedOfficers',
            fullText: 'WC Officers Inclusion / Exclusion',
            shortText: 'Included or Excluded Officers',
            value: null,
            description: 'Please attach forms for additional included or excluded officers.',
            additionalInfo: null,
            isRequired: false
        }
    ];
}


export const RenewalBillType = [
    {
        id: 'Direct',
        text: 'Direct Bill',
        isSelected: false
    },
    {
        id: 'Agency',
        text: 'Agency Bill',
        isSelected: false
    }
]

export class Contact {
    firstName: string = ""
    lastName: string = "";
    companyName: string = "";
    email: string = "";
    phone: string = "";
    roleName: string = "";
}

export class AuditContact extends Contact{
    roleName: string = ContactRoleType.Audit;
}

export class BillingContact extends Contact{
    roleName: string = ContactRoleType.Billing;
}

export class BindRenewal {
    selectedStep: string;
    fromReview: boolean = false;
    renewalData: any = new BindForm();
}